import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import AppsIcon from "@mui/icons-material/Apps";
import { useDispatch } from "react-redux";

import { openSidebar } from "../../../../store/ducks/duckSidebar";

function BasicToolbar(props) {
  const { pageName, id, children } = props;
  const dispatch = useDispatch();
  const handleSidebarOpen = () => {
    const globalStore = window.__REPORTS_REDUX_STORE__;

    if (globalStore?.dispatch) {
      globalStore.dispatch(openSidebar());

      return;
    }

    dispatch(openSidebar());
  };

  return (
    <Box sx={{ flexShrink: 0 }}>
      <AppBar id={id} position="static">
        <Toolbar
          sx={{
            minHeight: "38px !important",
            paddingLeft: "12px !important",
            paddingRight: "12px !important",
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            rowGap: "6px",
            columnGap: "8px",
          }}
        >
          <IconButton
            aria-label="sidebarOpen drawer"
            color="default"
            edge="start"
            size="small"
            sx={{
              mr: 1.5,
              backgroundColor: "transparent",
              color: "white",
              border: "none",
              outline: "none",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "transparent",
              },
              "&:focus": {
                outline: "none",
              },
              "&:focus-visible": {
                outline: "none",
              },
            }}
            onClick={handleSidebarOpen}
          >
            <AppsIcon data-cy="open-sidebar" sx={{ color: "#fff", fontSize: 20 }} />
          </IconButton>
          <Box
            component="img"
            alt="Reports"
            src={`${process.env.PUBLIC_URL}/ReportsNavbar.png`}
            sx={{
              width: "auto",
              height: 26,
              mr: 1,
              flexShrink: 0,
            }}
          />
          <Typography
            sx={{
              flex: "1 1 240px",
              fontSize: (theme) => theme.typography.pxToRem(15),
              lineHeight: 1,
              minWidth: 0,
              fontWeight: (theme) => theme.typography.fontWeightMedium,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {pageName}
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              flex: "1 1 420px",
              minWidth: 0,
              width: "100%",
              overflow: "hidden",
              pt: 1,
            }}
          >
            {children}
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export default BasicToolbar;
